export const environment = {
    production: false,
    api_reliance:'reliance',
    api_ckyc:'ckycService',
    baseUrl: 'https://testing.thepolicymall.com',
    api_icici:'https://rgipartners.reliancegeneral.co.in:9443',
    api_endpoint:"",
    payment_user: {
      username: "TrinityInsApp_test",
      password: "1oLsSoyFKkQ61KU9@",
      key: "a7gU7ZSfrTm8/Ktr9zcFpbknC8l7F445toeV3kvexxY=",
      iv: "D+jHPIEMbgB1Qs6HesbDGw==",
    },
    user_details: {
      clientId: 'TrinityIns',
      clientSecret: 'GEVkeuBwtQYQjPnrgaCBkMp39MezdbG2E0aonzKG1kI8chXfwObZq2Hsp0YXbGo7',
      username: 'TrinityIns',
      password: 'ej4cjdgv72eTFez',
      scope: 'esbpolicyrestriction',
      grantType: 'password',
      kycclientSecret: 'YENPLYary8VBJHhe2yXtbtQJ'
    },
    paymentApis: {
      transactionUrl: '/icici_payment/pgi/api/transaction/CreateBaseTransaction',
      paymentMethodUrl: 'https://ilesb01.insurancearticlez.com/pgi/payment/PaymentMethod',
      tokenUrl: '/icici_payment/pgi/api/token/generate',
      returnUrl: '/paymentResponse/paymentData',
      paymentVerication: '/icici_payment/pgi/api/transaction/TransactionEnquiry'
    },
    iciciApis: {
      tokenEndpoint: '/icici_token/generate-jwt-token',
      calculatePremiumEndpoint: '/api_icici/health/ilservices/health/v1/quote/getchiquote',
      checkpolicyrestrictiondetailsEndpoint: '/api_icici/health/ilservices/health/v1/generic/checkpolicyrestrictiondetails',
      getzoneendpoint: 'api_icici/health/ilservices/health/v1/generic/getzonedetail',
      proposalendpoint: '/api_icici/health/ilservices/health/v1/proposal/chicreateproposal',
      kyctokenEndpoint: '/icici_kyc/cerberus/connect/token',
      kycapiUrl: `/icici_kyc/ilservices/customer/v1/kyc/`,
      icici_kyc_encrypt_data: `/encryptRoute/encrypt`,
      paymenttaggingapi: '/api_icici/common/ilservices/payment/v1/payment',
    },
    iciciPlanCode : {
      "1A+1K_1Y": { code: 14225, name: "Apex_Plus_R_1A+1K_1_Year" },
      "1A+2K_1Y": { code: 14226, name: "Apex_Plus_R_1A+2K_1_Year" },
      "2A_1Y": { code: 14228, name: "Apex_Plus_R_2A_1_Year" },
      "2A+3K_1Y": { code: 14231, name: "Apex_Plus_R_2A+3K_1_Year" },
      "3A+2K_1Y": { code: 14234, name: "Apex_Plus_R_3A+2K_1_Year" },
      "2A+2K_1Y": { code: 14230, name: "Apex_Plus_R_2A+2K_1_Year" },
      "5A+1K_3Y": { code: 14285, name: "Apex_Plus_R_5A+1K_3_Year" },
      "1A+3K_1Y": { code: 14227, name: "Apex_Plus_R_1A+3K_1_Year" },
      "4A+1K_1Y": { code: 14237, name: "Apex_Plus_R_4A+1K_1_Year" },
      "5A+2K_1Y": { code: 14242, name: "Apex_Plus_R_5A+2K_1_Year" },
      "4A_1Y": { code: 14236, name: "Apex_Plus_R_4A_1_Year" },
      "6A+1K_1Y": { code: 14244, name: "Apex_Plus_R_6A+1K_1_Year" },
      "4A+3K_1Y": { code: 14239, name: "Apex_Plus_R_4A+3K_1_Year" },
      "2A+1K_1Y": { code: 14229, name: "Apex_Plus_R_2A+1K_1_Year" },
      "6A_1Y": { code: 14243, name: "Apex_Plus_R_6A_1_Year" },
      "1K_1Y": { code: 14223, name: "Apex_Plus_R_1K_1_Year" },
      "1A_1Y": { code: 14224, name: "Apex_Plus_R_1A_1_Year" },
      "3A+1K_1Y": { code: 14224, name: "Apex_Plus_R_3A+1K_1_Year" },
      "5A_1Y": { code: 14240, name: "Apex_Plus_R_5A_1_Year" },
      "2A+2K_3Y": { code: 14274, name: "Apex_Plus_R_2A+2K_3_Year" },
      "2A+3K_3Y": { code: 14275, name: "Apex_Plus_R_2A+3K_3_Year" },
      "3A_3Y": { code: 14276, name: "Apex_Plus_R_3A_3_Year" },
      "1A+3K_3Y": { code: 14271, name: "Apex_Plus_R_1A+3K_3_Year" },
      "3A+2K_3Y": { code: 14278, name: "Apex_Plus_R_3A+2K_3_Year" },
      "4A+1K_3Y": { code: 14281, name: "Apex_Plus_R_4A+1K_3_Year" },
      "3A+1K_3Y": { code: 14277, name: "Apex_Plus_R_3A+1K_3_Year" },
      "4A_3Y": { code: 14280, name: "Apex_Plus_R_4A_3_Year" },
      "5A_3Y": { code: 14284, name: "Apex_Plus_R_5A_3_Year" },
      "6A_3Y": { code: 14287, name: "Apex_Plus_R_6A_3_Year" },
      "1A_3Y": { code: 14268, name: "Apex_Plus_R_1A_3_Year" },
      "1K_3Y": { code: 14267, name: "Apex_Plus_R_1K_3_Year" },
      "1A+2K_3Y": { code: 14270, name: "Apex_Plus_R_1A+2K_3_Year" },
      "1A+1K_3Y": { code: 14269, name: "Apex_Plus_R_1A+1K_3_Year" },
      "2A_3Y": { code: 14272, name: "Apex_Plus_R_2A_3_Year" },
      "2A+1K_3Y": { code: 14273, name: "Apex_Plus_R_2A+1K_3_Year" },
      "5A+2K_3Y": { code: 14286, name: "Apex_Plus_R_5A+2K_3_Year" },
      "6A+1K_3Y": { code: 14288, name: "Apex_Plus_R_6A+1K_3_Year" },
      "3A_2Y": { code: 14254, name: "Apex_Plus_R_3A_2_Year" },
      "2A+3K_2Y": { code: 14253, name: "Apex_Plus_R_2A+3K_2_Year" },
      "2A+1K_2Y": { code: 14251, name: "Apex_Plus_R_2A+1K_2_Year" },
      "1A+2K_2Y": { code: 14248, name: "Apex_Plus_R_1A+2K_2_Year" },
      "1A+1K_2Y": { code: 14247, name: "Apex_Plus_R_1A+1K_2_Year" },
      "1A_2Y": { code: 14246, name: "Apex_Plus_R_1A_2_Year" },
      "2A_2Y": { code: 14250, name: "Apex_Plus_R_2A_2_Year" },
      "2A+2K_2Y": { code: 14252, name: "Apex_Plus_R_2A+2K_2_Year" },
      "1K_2Y": { code: 14245, name: "Apex_Plus_R_1K_2_Year" },
      "3A+2K_2Y": { code: 14256, name: "Apex_Plus_R_3A+2K_2_Year" },
      "3A+1K_2Y": { code: 14255, name: "Apex_Plus_R_3A+1K_2_Year" },
      "6A_2Y": { code: 14265, name: "Apex_Plus_R_6A_2_Year" },
      "6A+1K_2Y": { code: 14266, name: "Apex_Plus_R_6A+1K_2_Year" },
      "5A+2K_2Y": { code: 14264, name: "Apex_Plus_R_5A+2K_2_Year" },
      "5A+1K_2Y": { code: 14263, name: "Apex_Plus_R_5A+1K_2_Year" },
      "5A_2Y": { code: 14262, name: "Apex_Plus_R_5A_2_Year" },
      "4A+1K_2Y": { code: 14259, name: "Apex_Plus_R_4A+1K_2_Year" },
      "4A_2Y": { code: 14258, name: "Apex_Plus_R_4A_2_Year" },
      "4A+2K_2Y": { code: 14260, name: "Apex_Plus_R_4A+2K_2_Year" },
      "1A+3K_2Y": { code: 14249, name: "Apex_Plus_R_1A+3K_2_Year" },
      "3A_1Y": { code: 14232, name: "Apex_Plus_R_3A_1_Year" }
    },
    commonFixedData: {
      SubProductCode: 1186,
      TransactionType: "New",
      Zone_ProductCode: 3828,
      DealId: "DL-4193/1491884",
      SubProductName: "Apex_Plus_R",
      ChannelCode: "23",
      ChannelName: "FOS",
      ApplicationId: "375",
      Restriction_Product_code :4193,
    }
  };

  export const HDFCenvironment = {
    HDFCAPIURL :'/hdfc_url/cp//integration/heiintegrationservice/integration/',
    userDetails:{
      SOURCE: "TRINITY",
      CHANNEL_ID:"TRIN0001",
      PRODUCT_CODE : "2856",
      CREDENTIAL :"6E005500760061006700390076006400510068005A0054007A0071004B0067002B0070006F006A006E0077003D003D00",
      TRANSACTIONID:"2023080100101",
      agentId: "80180362",
      ChannelName: "HDFCLF"
     },
    kycCredential:{
      API_KEY:"d72c2ca6-05cb-46",
      APIURL: "/hdfc_kyc_url/e-kyc/tgt/generate-token"
    
     },
     getKycCredential:{
      SandboxBaseUrl:"/hdfc_kyc_url/e-kyc/primary/kyc-verified",
      redirect_url:"https://testing.thepolicymall.com/proposal",
      Channel:"Trinity Reinsurance Brokers Limited"
     },
     paymentDetails: {
      paymentURL:'https://heapp21.hdfcergo.com/UAT/OnlineProducts/CCPGISUBSCRIBER/MakePayment.aspx',
      checksumURL : '/hdfc_payment_url/UAT/PaymentUtilitiesService/PaymentUtilities.asmx',
      appId:10323,
      SubscriptionID: 'S000000358',
      SuccessUrl: '/hdfcpaymentResponse/hdfcpaymentData',
      FailureUrl: '/hdfcpaymentResponse/hdfcpaymentData',
     }
   };

   export const  CareEnviroment = {
    PartnerName: 'Partner_NB_Trinity',
    partnerId: "98",
    CareAdvantage: 6312,
    PreProposalappId: "554940",
    PostProposalappId:"213661",
    Signature: "VLwAATi/myXGqlG9C14DVIKsLgFjEUAZIizPSIbVdJw=",
    CareFreedom: 5502,
    CareHeart:  5226,
    TokenpartnerId :471966,
    baseAgentId: "20008325",
    securityKey:"dkpBQ0Q3cGVGb1NXVnNsWW1EaERWb0ErQVFyTGFhSytNZCtrVzdzRGtrOW1DWktaTDdwWHRWdVZoYnpyV1JseA==",
    applicationCD:'PARTNERAPP',
    apiUrl : "https://abacus.careinsurance.com/religare_api/api/web/v1",
    api_key: "GrYpE3JLMbtP3Lw8f3JX_pI8eyVT-dyG",
    auth_secret: "tNo5)Wqs5vvS",
    careTokenUrl : "/care_api_url/relinterfacerestful/religare/secure/restful/generatePartnerToken",
    policyStatus: "/care_api_url/relinterfacerestful/religare/secure/restful/getPolicyStatusV2",
    careReturnUrl : "/hdfcpaymentResponse/hdfcpaymentData",
    downloadPolicy: "/care_api_url/relinterfacerestful/religare/secure/restful/getPolicyPDFV2",
    carePaymentUrl : "https://apiuat.religarehealthinsurance.com/portalui/PortalPayment.run",
    carePanKycUrl : "/care_api_url/relinterfacerestful/religare/secure/restful/ckycDownload",
    careAadharKycUrl:  "/care_api_url/relinterfacerestful/religare/secure/restful/aadharCKYC",
    careProposalUrl: "/care_api_url/relinterfacerestful/religare/secure/restful/createPolicy"
   }
   export const goDigitEnviroment = {
    tokenEndpoint: '/OneAPI/digit/generateAuthKey',
    quoteEndPoint: '/goDigit/QuickQuote',
    proposalEndPoint: "/goDigit/Proposal",
    goDigitAPIEndPoint: "/goDigit/",
    ProductsCode :[{"PlanName":"Double Wallet Plan", "PlanCode":"DRP01",
  "Premium":null}, {"PlanName":"Infinity Wallet Plan", "PlanCode":"IRP01","Premium":null}, {"PlanName":"World Wide Treatment Plan","PlanCode":"WTP01",  "Premium":null}],
    Authorization: "KQYWO1TRVG1ZNX7BZPY7A2B4ZMNAAH64",
    kycReturnUrl: "/payment-success",
    coverTypeRHIMR:"48718",
    coverTypeHLINP: "48717"
 }
 